import { sifeEndpoints } from '../../../API/sifeEndpoints';
import { VERIFICATION_TYPES } from '../IdentityVerificationDialog/IdentityVerificationDialog.constants';
import { setVideoAgreementIdentityVerificationDialogVar } from './VideoAgreementIdentityVerificationDialog.vars';
import { HandleStartVideoAgreementIdentityVerificationParams } from './VideoAgreementIdentityVerificationDialog.types';
import {
  globalBackdropVar,
  globalSnackbarVar,
} from '../../../cache.reactiveVars';

export const handleStartVideoAgreementIdentityVerification = async (
  params: HandleStartVideoAgreementIdentityVerificationParams,
) => {
  const {
    stepNumberLabel,
    videoAgreementTextToRead,
    onFinish,
    onStarted,
    onClose,
  } = params;

  try {
    globalBackdropVar({
      open: true,
      clickable: false,
      text: 'Iniciando verificación...',
    });
    const response = await sifeEndpoints.startVerification.post({
      process:
        VERIFICATION_TYPES.CRYPTO_SIGNATURE_CREATION_WITH_VIDEO_AGREEMENT,
      videoAgreementTextToRead,
    });

    if (response.status === 200) {
      const { verificationId } = response.data.data;

      onStarted && onStarted();
      setVideoAgreementIdentityVerificationDialogVar({
        open: true,
        verificationId,
        stepNumberLabel: stepNumberLabel || '',
        textToRead: videoAgreementTextToRead,
        onFinish,
        onClose,
      });
      return;
    }

    globalSnackbarVar({
      show: true,
      message: 'Ocurrió un error al iniciar la verificación',
      severity: 'error',
    });
  } catch {
    globalSnackbarVar({
      show: true,
      message: 'Ocurrió un error, contacte a Sora',
      severity: 'error',
    });
  } finally {
    globalBackdropVar({ open: false });
  }
};
